/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LclFeeInfoDto } from './LclFeeInfoDto';
import {
    LclFeeInfoDtoFromJSON,
    LclFeeInfoDtoFromJSONTyped,
    LclFeeInfoDtoToJSON,
    LclFeeInfoDtoToJSONTyped,
} from './LclFeeInfoDto';

/**
 * 
 * @export
 * @interface ResponseLclFeeInfoDto
 */
export interface ResponseLclFeeInfoDto {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseLclFeeInfoDto
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseLclFeeInfoDto
     */
    message?: string;
    /**
     * 
     * @type {LclFeeInfoDto}
     * @memberof ResponseLclFeeInfoDto
     */
    data?: LclFeeInfoDto;
}

/**
 * Check if a given object implements the ResponseLclFeeInfoDto interface.
 */
export function instanceOfResponseLclFeeInfoDto(value: object): value is ResponseLclFeeInfoDto {
    return true;
}

export function ResponseLclFeeInfoDtoFromJSON(json: any): ResponseLclFeeInfoDto {
    return ResponseLclFeeInfoDtoFromJSONTyped(json, false);
}

export function ResponseLclFeeInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseLclFeeInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : LclFeeInfoDtoFromJSON(json['data']),
    };
}

export function ResponseLclFeeInfoDtoToJSON(json: any): ResponseLclFeeInfoDto {
    return ResponseLclFeeInfoDtoToJSONTyped(json, false);
}

export function ResponseLclFeeInfoDtoToJSONTyped(value?: ResponseLclFeeInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': LclFeeInfoDtoToJSON(value['data']),
    };
}

